<template>
  <div v-focus class="sign-out" tabindex="0" @keyup.esc="$emit('exit', false)">
    <img v-if="language === 'en'" src="@/assets/signout/backgrounExitcomic_en.png" alt="" class="background-img" />
    <img v-else src="@/assets/signout/backgrounExitcomic_es.png" alt="" class="background-img" />
    <div class="body">
      <img
        v-if="language === 'en'"
        src="@/assets/signout/exitComicYes.png"
        alt=""
        class="yes"
        @click="$emit('exit', true)"
      />
      <img v-else src="@/assets/signout/exitComicSi.png" alt="" class="yes" @click="$emit('exit', true)" />
      <img src="@/assets/signout/exitComicNo.png" alt="" class="no" @click="$emit('exit', false)" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['language']),
  },
};
</script>
<style lang="scss" scoped>
.sign-out {
  .background-img {
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -150px;
    margin-left: -250px;
    height: 300px;
    width: 500px;
    z-index: 0;
  }
  .body {
    position: fixed;
    top: 50%;
    margin-top: -150px;
    left: 50%;
    margin-left: -250px;
    height: 300px;
    width: 500px;
    display: flex;
    justify-content: center;
    .yes,
    .no {
      top: 50%;
      left: 50%;
      width: 180px;
      height: 70px;
      position: fixed;
      &:hover {
        cursor: pointer;
        transform: scale(1.1);
      }
    }
    .yes {
      margin-top: 45px;
      margin-left: -220px;
    }
    .no {
      margin-top: 20px;
      margin-left: 40px;
    }
  }
}
</style>
